import { render } from "./ChatBot.vue?vue&type=template&id=1090fc94&scoped=true"
import script from "./ChatBot.vue?vue&type=script&lang=js"
export * from "./ChatBot.vue?vue&type=script&lang=js"

import "./ChatBot.vue?vue&type=style&index=0&id=1090fc94&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1090fc94"

export default script